module.exports = __webpack_public_path__ + "img/Group196.24ed013a.png";